import { PaintStyle } from "../../drawing";
import { AbstractRectangleItem } from "./AbstractRectangleItem";
import { TypeKeys } from "./TypeKeys";
import { RelationalActionParameter } from "./RelationalActionParameter";
import { UpdateKinds } from "../UpdateKinds";
import { ExternalSubItem } from "./ExternalSubItem";
import { IExternalScriptExecutable } from "./IExternalScriptExecutable";
import { IPaintableOnEditing } from "./IPaintableOnEditing";

// 暫定で追加したのみの状態
// V1フォーマット上ではscriptlinkタグ
// [参考資料]
// \\192.168.2.222\共通フォルダ他\★Documaker\11_システム定義書\外部処理\【外部処理】外部処理について.xlsx
// http://git.pscad.co.jp:8080/gitbucket/documaker/DocuMakerV1.5/blob/5f00b8a1c8ed1f68f703a218157e85242d5c569c/src/findex/documaker/print/screen/data/FormatDataModel.java#L3110
export class ExternalProcessItem extends AbstractRectangleItem implements IExternalScriptExecutable, IPaintableOnEditing {
  constructor() {
    super(TypeKeys.ExternalProcessItem);
  }

  public name: string = "";
  public actions: RelationalActionParameter[] = [];
  public exePath: string = null;
  public csvPath: string = null;
  public xmlValuePath: string = null;
  public csvBeforeValuePath: string = null;
  public csvInputValuePath: string = null;
  public updateKind: UpdateKinds = null;
  public splitter: string = null;
  public items: ExternalSubItem[] = [];
  public previousCsvBinary: string = null; // TODO:そもそも外部プロセスに必要？
  public paintStyle: PaintStyle = new PaintStyle();
  public paintStyleOnEditing: PaintStyle = null;
  public textFontSize: number = null;

  protected createCloneInstance(): ExternalProcessItem {
    return new ExternalProcessItem();
  }

  protected applyMembers(clone: ExternalProcessItem): void {
    super.applyMembers(clone);
    clone.name = this.cloneValue(this.name);
    clone.actions = this.cloneValue(this.actions);
    clone.exePath = this.cloneValue(this.exePath);
    clone.csvPath = this.cloneValue(this.csvPath);
    clone.xmlValuePath = this.cloneValue(this.xmlValuePath);
    clone.csvBeforeValuePath = this.cloneValue(this.csvBeforeValuePath);
    clone.csvInputValuePath = this.cloneValue(this.csvInputValuePath);
    clone.updateKind = this.cloneValue(this.updateKind);
    clone.splitter = this.cloneValue(this.splitter);
    clone.items = this.cloneValue(this.items);
    clone.previousCsvBinary = this.cloneValue(this.previousCsvBinary);
    clone.paintStyle = this.cloneValue(this.paintStyle);
    clone.paintStyleOnEditing = this.cloneValue(this.paintStyleOnEditing);
    clone.textFontSize = this.cloneValue(this.textFontSize);
  }

  getDisplayName(): string {
    return this.name;
  }
}
